const DataSoalPretestPG = [
  {
    id: "1",
    tipe: "pilihan-ganda",
    soal: "Palang Merah Indonesia didirikan pada tanggal. . .",
    jawaban1: "17 Agustus 1954",
    jawaban2: "17 Agustus 1945",
    jawaban3: "17 September 1954",
    jawaban4: "17 September 1945",
  },
  {
    id: "2",
    tipe: "pilihan-ganda",
    soal: "Dalam pertolongan pertama apa arti dari GSS. . .",
    jawaban1: "Gerakan Secara Sadar",
    jawaban2: "Gerakan Sadar Simulasi",
    jawaban3: "Gerakan Sekali Simultan",
    jawaban4: "Gerakan Sensasi Sirkulasi",
  },
  {
    id: "3",
    tipe: "pilihan-ganda",
    soal: "Susunan sistem pernafasan yang benar adalah. . .",
    jawaban1: "Hidung-Faring-Trakea-Bronkus-Laring",
    jawaban2: "Hidung-Bronkus-Laring-Faring-Trakea",
    jawaban3: "Mulut-Trakea-Bronkus-Faring-Laring",
    jawaban4: "Hidung-Faring-Laring-Trakea-Bronkus",
  },
  {
    id: "4",
    tipe: "pilihan-ganda",
    soal: "Yang tidak termasuk tanda dan gejala syok adalah. . .",
    jawaban1: "Nadi cepat dan lemah",
    jawaban2: "Nadi cepat dan dangkal",
    jawaban3: "kejang",
    jawaban4: "Terjadi sianosis di bibir",
  },
  {
    id: "5",
    tipe: "pilihan-ganda",
    soal: "Kapan Resusitasi Jantung Paru perlu dilakukan . . .",
    jawaban1: "Pada saat tidak ada nadi",
    jawaban2: "Pada saat tidak ada nafas",
    jawaban3: "Pada saat tidak ada nadi dan nafas",
    jawaban4: "Pada saat ada nadi dan nafas",
  },
]

export default DataSoalPretestPG
